module.exports = __webpack_public_path__ + "img/promociones.538fd1a4.webp";